<script setup lang="ts">

import type {Workspace} from "~/types/spaces.types";
import {deleteWorkspace} from "~/calls/workspace";
import {useUiNotifications} from "~/stores/ui-notifications";

const props = defineProps<{
  workspace: Workspace
}>();

const {showUiNotification} = useUiNotifications();
const onDelete = () => {
  deleteWorkspace(props.workspace.identifier).then((r) => {
    if (!r.success) return false
    showUiNotification({
      message: `Workspace has been deleted`,
      type: 'success'
    })
    return true
  })
}
</script>

<template>
  <v-card variant="tonal" color="lightprimary" elevation="1">
    <v-card-item class="py-2 px-4 bg-lightprimary">
      <v-card-title class="text-h6 d-flex align-center justify-space-between">
        {{ workspace.name }}
      </v-card-title>

    </v-card-item>
    <v-divider/>
    <v-list v-if="workspace.environments.length > 0">
      <v-list-item class="d-flex align-center" :to="`/workspace/${workspace.identifier}/env/${env.identifier}/`"
                   v-for="env in workspace.environments" :value="env" :key="env.identifier"
                   color="primary">
        <template v-slot:prepend>
          <component is="CubeIcon" size="18" stroke-width="1.5" class="mr-1"/>
        </template>
        <v-list-item-title v-text="env.name"></v-list-item-title>
      </v-list-item>
    </v-list>
    <div v-else>
      <v-alert type="warning">
        <div>
          Whoops! No environments were found.
        </div>

        <v-btn variant="text" color="primary" @click="onDelete()" class="mt-2">
          Delete
        </v-btn></v-alert>
    </div>
  </v-card>
</template>
